import { GetServerSidePropsContext } from "next";
import Home from "views/index";
import { GetFrontPlayground, GetFrontModules, GetSeoInfo } from "services/page/app";
import { parseProductTagFromUrl } from "utils/playground/url";
import { IncomingMessage } from "http";
import { reconstructFrontMods } from "serverutils/initProductInfo";
import { CommonRuntime, getMeta, moduleSliceNumber } from "utils/runtime";
import { isNotBlankArray } from "utils/array";
import e from "utils/catchAsyncError";
import { s } from "utils/sentryEvent";
import { AppLogger } from "ez-node-monitor";
import { getRuntime } from "serverutils/runtime";

type IncomingMessagePro = IncomingMessage & {
	cookies: { [key: string]: string };
	runtime?: CommonRuntime;
};
export interface GetServerSidePropsContextPro extends GetServerSidePropsContext {
	req: IncomingMessagePro;
}

async function getPlaygroundInfo(ctx: GetServerSidePropsContextPro, runtime: CommonRuntime) {
	const { query } = ctx || {};
	const { id = "", version } = runtime;
	const meta = getMeta(runtime);
	const tag: string = (query.tag as string) || "";

	const [, playgroundData] = await e(GetFrontPlayground)(
		{
			id,
			meta,
			version,
		},
		{ runtime },
	);

	const tagQuery = parseProductTagFromUrl(tag || "");
	let frontMods = {};
	if (isNotBlankArray(playgroundData?.modules)) {
		const moduleId: string[] = [
			...playgroundData.modules
				.filter((item) => item.header?.position)
				.map((item) => item.id),
		];
		const [, modRes] = await e(GetFrontModules)(
			{
				moduleId,
				meta,
			},
			{
				runtime,
			},
		);
		if (modRes?.mods) {
			frontMods = await s(reconstructFrontMods)({
				mods: modRes.mods,
				tagQuery,
				runtime,
			});
		}
	}
	console.log("frontMods: ", frontMods);
	const mods = frontMods ? Object.values(frontMods) : [];
	return {
		modules: playgroundData?.modules || [],
		page: playgroundData?.page || null,
		frontModules: mods.slice(0, moduleSliceNumber),
		lastFrontModules: mods.slice(moduleSliceNumber, mods.length),
		tagQuery,
	};
}
export const getServerSideProps = async (ctx: GetServerSidePropsContextPro) => {
	const { req } = ctx || {};
	const requestUrl = req.url!;
	AppLogger.info(`[consul] [page request url is] ${requestUrl}`);
	const str = requestUrl.split("/active/")[1];
	const [id] = str.split("/");
	const runtime = await getRuntime(req as any);

	const [seoResp, playgroundInfoResp] = await Promise.all([
		e(GetSeoInfo)({ pageId: id }, { runtime }),
		getPlaygroundInfo(ctx, runtime as CommonRuntime),
	]);
	const [, seoInfo] = seoResp;
	const { modules, page, frontModules, lastFrontModules, tagQuery } = playgroundInfoResp;

	console.log("playgroundInfoResp: ", playgroundInfoResp);
	return {
		props: {
			modules,
			page,
			frontModules,
			lastFrontModules,
			runtime,
			tagQuery,
			title:
				seoInfo?.multiTitle?.[runtime.languageCode] ||
				seoInfo?.multiTitle?.["en"] ||
				seoInfo?.pageName ||
				page?.name ||
				"",
		},
	};
};

export default Home;
